import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home"*/ "../views/Home.vue"),
  },
  {
    path: "/dashboard",
    redirect: { name: "Home" },
  },
  {
    path: "/track",
    name: "TrackGame",
    component: () =>
      import(/* webpackChunkName: "track_game" */ "../views/TrackGame.vue"),
  },
  {
    path: "/results",
    name: "ResultsGrid",
    component: () =>
      import(/* webpackChunkName: "results_grid" */ "../views/ResultsGrid.vue"),
  },
  {
    path: "/support_the_site",
    name: "SupportTheSite",
    component: () =>
      import(
        /* webpackChunkName: "support_the_site" */ "../views/SupportTheSite.vue"
      ),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
  },
  {
    path: "/report",
    name: "ReportAbuse",
    component: () =>
      import(/* webpackChunkName: "report_abuse" */ "../views/ReportAbuse.vue"),
  },
  {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/PrivacyPolicy.vue"),
  },
  {
    path: "/terms",
    name: "Terms",
    component: () =>
      import(/* webpackChunkName: "terms" */ "../views/Terms.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    beforeEnter: (to, from, next) => {
      if (from.name) {
        localStorage.setItem("prelogin_route", from.path);
      } else {
        localStorage.removeItem("prelogin_route");
      }
      next();
    },
  },
  {
    path: "/set_username",
    name: "SetUsername",
    component: () =>
      import(/* webpackChunkName: "set_username" */ "../views/SetUsername.vue"),
    beforeEnter: (to, from, next) => {
      // When verifying with Google, check if the user has been logged in.
      // If not,
      const isLoggedIn = store.getters.isLoggedIn;
      if (isLoggedIn) {
        const prevRoute = localStorage.getItem("prelogin_route");
        const redirect = prevRoute || { name: "Home" };
        next(redirect);
      }
      next();
    },
  },
  {
    path: "/decks",
    name: "DeckList",
    component: () =>
      import(/* webpackChunkName: "deck_list" */ "../views/DeckList.vue"),
  },
  {
    path: "/decks/create",
    name: "CreateDeck",
    component: () =>
      import(/* webpackChunkName: "create_deck" */ "../views/CreateDeck.vue"),
  },
  {
    path: "/decks/:id",
    name: "EditDeck",
    props: true,
    component: () =>
      import(/* webpackChunkName: "edit_deck" */ "../views/EditDeck.vue"),
  },
  {
    path: "/decks/:familyId/versions/:id",
    name: "EditVersion",
    props: true,
    component: () =>
      import(/* webpackChunkName: "edit_deck" */ "../views/EditDeck.vue"),
  },
  {
    path: "/u/:username/decks",
    name: "UserDeckList",
    props: true,
    component: () =>
      import(/* webpackChunkName: "user_decks" */ "../views/UserDeckList.vue"),
  },
  {
    path: "/u/:username/results",
    name: "UserResultsGrid",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "user_results" */ "../views/UserResultsGrid.vue"
      ),
  },
  {
    path: "/resources",
    name: "Resources",
    component: () =>
      import(/* webpackChunkName: "resources" */ "../views/Resources.vue"),
  },
  {
    path: "/posts/:sectionSlug",
    name: "PostsSection",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "posts_section" */ "../views/PostsSection.vue"
      ),
  },
  {
    path: "/post/:postSlug",
    name: "SinglePost",
    props: true,
    component: () =>
      import(/* webpackChunkName: "single_post" */ "../views/SinglePost.vue"),
  },
  {
    path: "/umdb",
    component: () =>
      import(/* webpackChunkName: "umdb" */ "../views/UmDb/UmDb.vue"),
    children: [
      {
        path: "",
        name: "UmDb",
        redirect: () => {
          const tabName =
            store.state.userPreferences.umdbTabName || "UmDbDeckList";
          return { name: tabName };
        },
      },
      {
        path: "sets",
        name: "UmDbSetList",
        component: () =>
          import(
            /* webpackChunkName: "umdb_setlist" */ "../views/UmDb/UmDbSetList.vue"
          ),
      },
      {
        path: "boards",
        name: "UmDbBoardList",
        component: () =>
          import(
            /* webpackChunkName: "umdb_boardlist" */ "../views/UmDb/UmDbBoardList.vue"
          ),
      },
      {
        path: "decks",
        name: "UmDbDeckList",
        props: { selectedGroups: ["info"] },
        component: () =>
          import(
            /* webpackChunkName: "umdb_decklist" */ "../views/UmDb/UmDbDeckList.vue"
          ),
      },
      {
        path: "decks/stats",
        name: "UmDbDeckStats",
        props: { selectedGroups: ["stats"] },
        component: () =>
          import(
            /* webpackChunkName: "umdb_deckstatslist" */ "../views/UmDb/UmDbDeckList.vue"
          ),
      },
      {
        path: "decks/:slug",
        name: "UmDbDeck",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "umdb_deck" */ "../views/UmDb/UmDbDeck.vue"
          ),
      },
      {
        path: "cards",
        name: "UmDbCardList",
        component: () =>
          import(
            /* webpackChunkName: "umdb_cardlist" */ "../views/UmDb/UmDbCardList.vue"
          ),
      },
      {
        path: "cards/:slug",
        name: "UmDbCard",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "umdb_card" */ "../views/UmDb/UmDbCard.vue"
          ),
      },
    ],
  },

  {
    path: "/*",
    name: "Error",
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/ErrorPage.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((_, __, next) => {
  store.dispatch("checkLoggedIn").then(() => next());
});

export default router;
